import { OrganizationRole } from '@organization/api/requests'
import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  role?: OrganizationRole
}

const RoleTag = {
  [OrganizationRole.ADMIN]: 'green',
  [OrganizationRole.EMPLOYEE]: 'yellow',
  [OrganizationRole.OWNER]: 'red'
}

export const UserRoleTag = ({ role }: Props) => {
  const { t } = useTranslation()

  return (
    <Tag color={RoleTag[role ?? OrganizationRole.EMPLOYEE]}>
      {t(`role.${role ?? OrganizationRole.EMPLOYEE}`)}
    </Tag>
  )
}
